import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, // Button,
// BorrowerDocuments,
// BorrowerIdCardForm,
BorrowerFiles // BorrowerDocumentsHistory,
} from 'components'; // import { getDocumentImages } from 'services';
// import { showApiError } from 'utils';

import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerDocumentsTab = function BorrowerDocumentsTab(props) {
  var idNumber = props.idNumber,
      borrower = props.borrower; // const [documents, setDocuments] = useState();
  // const [isEdit, setIsEdit] = useState(false);
  // useEffect(() => {
  //   fetchBorrowerDocuments();
  // }, []);
  // const fetchBorrowerDocuments = async () => {
  //   const [res, err] = await getDocumentImages(idNumber);
  //   if (err) return showApiError(err);
  //   setDocuments(res);
  // };
  // const handleSaveDocuments = data => {
  //   setIsEdit(false);
  //   data && fetchBorrowerDocuments();
  // };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: "\u0424\u0430\u0439\u043B\u043E\u0432\u0435",
    margin: "0 0 2em 0"
  }, ___EmotionJSX(BorrowerFiles, {
    borrowerIdNumber: idNumber,
    documents: borrower === null || borrower === void 0 ? void 0 : borrower.documents
  })))));
};

BorrowerDocumentsTab.propTypes = {
  idNumber: PropTypes.string,
  borrower: PropTypes.object
};
export default BorrowerDocumentsTab;